import { useState } from "react";
import {
  Typography,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Fragment } from "react";
import "./CreateProductForm.css";
import { useDispatch } from "react-redux";
import { createProduct } from "../../../Redux/Customers/Product/Action";

const initialSizes = [
  { name: "S", quantity: 0 },
  { name: "M", quantity: 0 },
  { name: "L", quantity: 0 },
];

const CreateProductForm = () => {
  const [productData, setProductData] = useState({
  colorVariants: [
    {
      color: "",
      images: [
        { label: "front", url: "" },
        { label: "back", url: "" },
      ],
    },
  ],
  brand: "",
  title: "",
  discountedPrice: "",
  price: "",
  discountPersent: "",
  size: initialSizes,
  quantity: "",
  topLavelCategory: "",
  secondLavelCategory: "",
  thirdLavelCategory: "",
  description: "",
  faq: [ { question: "", answer: "" } ], // ✅ Add this
});

  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSizeChange = (e, index) => {
    let { name, value } = e.target;
    name = name === "size_quantity" ? "quantity" : name;

    const sizes = [...productData.size];
    sizes[index][name] = value;
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  const handleAddSize = () => {
    const sizes = [...productData.size];
    sizes.push({ name: "", quantity: "" });
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  const handleColorVariantChange = (e, index, imageLabel = null) => {
    const { value } = e.target;
    const updatedVariants = [...productData.colorVariants];

    if (imageLabel) {
      const imgIndex = updatedVariants[index].images.findIndex(
        (img) => img.label === imageLabel
      );
      if (imgIndex !== -1) {
        updatedVariants[index].images[imgIndex].url = value;
      }
    } else {
      updatedVariants[index].color = value;
    }

    setProductData((prevState) => ({
      ...prevState,
      colorVariants: updatedVariants,
    }));
  };

  const handleAddColorVariant = () => {
    setProductData((prevState) => ({
      ...prevState,
      colorVariants: [
        ...prevState.colorVariants,
        {
          color: "",
          images: [
            { label: "front", url: "" },
            { label: "back", url: "" },
            { label: "side", url: "" },
            { label: "detail", url: "" },
            { label: "closeup", url: "" },
            { label: "fullview", url: "" },
          ],
        },
      ],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...productData,
      colorVariants: productData.colorVariants.map((variant) => ({
        color: variant.color,
        images: variant.images
          .filter((img) => img.label === "front" || img.label === "back")
          .map((img) => ({
            label: img.label,
            url: img.url,
          })),
      })),
      price: Number(productData.price),
      discountedPrice: Number(productData.discountedPrice),
      discountPersent: Number(productData.discountPersent),
      quantity: Number(productData.quantity),
      size: productData.size.map((s) => ({
        name: s.name,
        quantity: Number(s.quantity),
      })),
      faq: productData.faq.filter((f) => f.question && f.answer),
    };

    dispatch(createProduct({ data: payload, jwt }));
    console.log(payload);
  };
   const handleFaqChange = (e, index) => {
  const { name, value } = e.target;
  const updatedFaq = [...productData.faq];
  updatedFaq[index][name] = value;

  setProductData((prevState) => ({
    ...prevState,
    faq: updatedFaq,
  }));
};

const handleAddFaq = () => {
  setProductData((prevState) => ({
    ...prevState,
    faq: [...prevState.faq, { question: "", answer: "" }],
  }));
};

  return (
    <Fragment>
      <Typography variant="h3" sx={{ textAlign: "center" }} className="py-10">
        Add New Product
      </Typography>
      <form
        onSubmit={handleSubmit}
        className="createProductContainer min-h-screen"
      >
        <Grid container spacing={2}>
          {/* Color Variants Section */}
          <Grid item xs={12}>
            <Typography variant="h6">Color Variants</Typography>
          </Grid>

          {productData.colorVariants.map((variant, index) => (
            <Fragment key={index}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Color Name"
                    value={variant.color}
                    onChange={(e) => handleColorVariantChange(e, index)}
                  />
                </Grid>

                {/* Original 3 images */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Front Image URL"
                    value={variant.images[0].url}
                    onChange={(e) =>
                      handleColorVariantChange(e, index, "front")
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Back Image URL"
                    value={variant.images[1].url}
                    onChange={(e) => handleColorVariantChange(e, index, "back")}
                  />
                </Grid>
              </Grid>
            </Fragment>
          ))}

          <Grid item xs={12}>
            <Button variant="outlined" onClick={handleAddColorVariant}>
              Add More Color Variants
            </Button>
          </Grid>

          {/* Rest of the form remains the same */}
          {/* Product Details */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Brand"
              name="brand"
              value={productData.brand}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={productData.title}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Quantity"
              name="quantity"
              value={productData.quantity}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Price"
              name="price"
              value={productData.price}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discounted Price"
              name="discountedPrice"
              value={productData.discountedPrice}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discount Percentage"
              name="discountPersent"
              value={productData.discountPersent}
              onChange={handleChange}
              type="number"
            />
          </Grid>

          {/* Category Dropdowns */}
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Top Level Category</InputLabel>
              <Select
                name="topLavelCategory"
                value={productData.topLavelCategory}
                onChange={handleChange}
              >
                <MenuItem value="product">Product</MenuItem>
                <MenuItem value="women">Women</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Second Level Category</InputLabel>
              <Select
                name="secondLavelCategory"
                value={productData.secondLavelCategory}
                onChange={handleChange}
              >
                <MenuItem value="econirmit">Econirmit</MenuItem>
                {/* <MenuItem value="clothing">Clothing</MenuItem>
                <MenuItem value="kurti">Kurti</MenuItem>
                <MenuItem value="accessories">Accessories</MenuItem>
                <MenuItem value="brands">Brands</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <InputLabel>Third Level Category</InputLabel>
              <Select
                name="thirdLavelCategory"
                value={productData.thirdLavelCategory}
                onChange={handleChange}
              >
                <MenuItem value="all">All</MenuItem>
             
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <InputLabel variant="h6">FAQs</InputLabel>
          </Grid>

          {productData.faq.map((item, index) => (
            <Grid container spacing={2} key={index}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Question"
                  name="question"
                  value={item.question}
                  onChange={(e) => handleFaqChange(e, index)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Answer"
                  name="answer"
                  value={item.answer}
                  onChange={(e) => handleFaqChange(e, index)}
                />
              </Grid>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button variant="outlined" onClick={handleAddFaq}>
              Add More FAQ
            </Button>
          </Grid>

          {/* Description */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              multiline
              rows={3}
              name="description"
              value={productData.description}
              onChange={handleChange}
            />
          </Grid>

          {/* Sizes */}
          {/* {productData.size.map((size, index) => (
            <Grid container item spacing={3} key={index}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Size Name"
                  name="name"
                  value={size.name}
                  onChange={(e) => handleSizeChange(e, index)}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Quantity"
                  name="size_quantity"
                  type="number"
                  value={size.quantity}
                  onChange={(e) => handleSizeChange(e, index)}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          ))} */}

          {/* <Grid item xs={12}>
            <Button variant="outlined" onClick={handleAddSize}>
              Add More Sizes
            </Button>
          </Grid> */}

          <Grid item xs={12}>
            <Button
              variant="contained"
              type="submit"
              size="large"
              sx={{ p: 1.8 }}
            >
              Add New Product
            </Button>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  );
};

export default CreateProductForm;
